<div [ngSwitch]="templatePrefix" *ngIf="!isLoading">
  <!-- HMM spark skills screen hmm is only in english -->
  <div *ngSwitchCase="'hmm-'" class="grid">
    <div class="grid__col-10 center-item center-text">
      <h2 class="h2" tabindex="-1" dgxAutofocus>
        What skills would you like to develop?
      </h2>
      <p class="par guts-p-t-1">(Choose at least one)</p>
      <div class="guts-p-t-2">
        <dgx-hmm-tag-picker
          (tagSelected)="onSkillSelected($event)"
        ></dgx-hmm-tag-picker>
      </div>
    </div>
  </div>
</div>
